import { AdditionalBlockData } from "models/interfaces/additional-block-data/additional-block-data";
import { PageBlockContent } from "molecules/page-block-content/page-block-content";
import { PAGE_BLOCK_CSS_CLASS_NAME } from "organisms/page-blocks/page-block-list/inactive-page-block";
import { ReadonlyPageBlockProps } from "organisms/page-blocks/readonly-page-block/readonly-page-block";
import React from "react";

interface ReadonlyPageBlockContentProps extends ReadonlyPageBlockProps {
    additionalBlockData: AdditionalBlockData;
}

export const ReadonlyPageBlockContent = ({
    additionalBlockData,
    block,
    printable = false,
}: ReadonlyPageBlockContentProps) => {
    return (
        <article className={PAGE_BLOCK_CSS_CLASS_NAME}>
            <PageBlockContent
                additionalBlockData={additionalBlockData}
                block={block}
                printable={printable}
                onBlockSaved={() => {}}
            />
        </article>
    );
};
